import { render, staticRenderFns } from "./AdminChannel.vue?vue&type=template&id=409d9644&scoped=true&"
import script from "./AdminChannel.ts?vue&type=script&lang=ts&"
export * from "./AdminChannel.ts?vue&type=script&lang=ts&"
import style0 from "./AdminChannel.vue?vue&type=style&index=0&id=409d9644&scoped=true&lang=css&"
import style1 from "./AdminChannel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409d9644",
  null
  
)

export default component.exports